import z from "zod"

export const SegmentResponseDataSchema = z.object({
  id: z.union([z.bigint(), z.string()]).transform(String),
  groupId: z.union([z.bigint(), z.string()]).transform(String),
  name: z.string(),
  createdAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val)),
  updatedAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val)),
  archivedAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val))
    .optional()
    .nullable(),
  count: z.number(),
})

export const SegmentsResponseDataSchema = z.array(SegmentResponseDataSchema)

const SegmentGroupType = {
  Fixed: "Fixed",
  Dynamic: "Dynamic",
} as const

export type SegmentGroupType = (typeof SegmentGroupType)[keyof typeof SegmentGroupType]

export const SegmentGroupResponseDataSchema = z.object({
  id: z.union([z.bigint(), z.string()]).transform(String),
  name: z.string(),
  isPredefined: z.boolean(),
  type: z.nativeEnum(SegmentGroupType),
  rules: z.any(),
  createdAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val)),
  updatedAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val)),
  archivedAt: z
    .union([z.date(), z.string()])
    .transform((val) => (val instanceof Date ? val.toISOString() : val))
    .optional()
    .nullable(),
  segments: SegmentsResponseDataSchema,
  customersCount: z.number(),
})

export const SegmentGroupsResponseDataSchema = z.array(SegmentGroupResponseDataSchema)

export const SegmentGroupStatsResponseDataSchema = z.object({
  currentStabilityScore: z.number(),
  previousStabilityScore: z.number(),
  totalCustomers: z.number(),
  customersInGroup: z.number(),
  newSegments: z.number(),
})

export const SegmentGroupShopifyMetricsResponseDataSchema = z.array(
  z.object({
    segmentId: z.bigint().transform(String),
    avgDaysSinceLastOrder: z.number().nullable(),
    ordersCount: z.bigint().nullable().transform(Number),
    amountSpent: z.number().nullable(),
    currency: z.string().nullable(),
  }),
)

const OverlappingSegmentResponseDataSchema = z.object({
  id: z.union([z.bigint(), z.number(), z.string()]).transform(String),
  name: z.string(),
  overlapCount: z.number(),
  overlapPercentage: z.number().optional(), // New field for overlap percentage
})

export const SegmentGroupComparisonResponseDataSchema = z.array(
  z.object({
    id: z.union([z.bigint(), z.number(), z.string()]).transform(String),
    name: z.string(),
    count: z.number(),
    percentage: z.number().optional(), // New field for segment's percentage of total
    overlappingSegments: z.array(OverlappingSegmentResponseDataSchema),
  }),
)
